<div class="embed-responsive embed-responsive-1by1">
    <iframe class="embed-responsive-item" src="https://datastudio.google.com/embed/reporting/5d8fb937-7b9f-4298-8b41-d67198e0fb50/page/UdaTB"></iframe>
  </div>